import React from "react";
import { Modal, Typography, Divider } from "antd";

const { Title, Text, Link, Paragraph } = Typography;

const resourceInfo = [
  {
    id: "cop-temp-global",
    source: "Copernicus Marine Environment Monitoring Service",
    format: "NetCDF",
    layerType: "Heatmap + WebGL",
    measureType:
      "Temperatura potencial del agua (thetao) ajustada a la presión",
    coverage: "Cobertura mundial (latitudes –80 a 90; longitudes –180 a 179)",
    description:
      "Capa tipo heatmap que muestra la temperatura potencial del agua ajustada a la presión, permitiendo analizar la estratificación y dinámica térmica global.",
    moreInfo: "https://marine.copernicus.eu/",
  },
  {
    id: "pde-temp-GIB",
    source: "Puertos del Estado (PDE)",
    format: "NetCDF",
    layerType: "Heatmap + WebGL",
    measureType: "Temperatura en el Estrecho de Gibraltar",
    coverage: "Latitudes 35 a 37.2, longitudes –7.42 a –2.99",
    description:
      "Heatmap de temperatura en el Estrecho de Gibraltar, zona de transición entre aguas atlánticas y mediterráneas.",
    moreInfo: "https://portus.puertos.es/",
  },
  {
    id: "pde-temp-ALM",
    source: "Puertos del Estado (PDE)",
    layerType: "Heatmap + WebGL",
    format: "NetCDF",
    measureType: "Temperatura en la Costa de Almería",
    coverage: "Latitudes 36.46 a 36.86, longitudes –2.65 a –2.21",
    description:
      "Heatmap que muestra la temperatura en la Costa de Almería, proporcionando datos críticos para analizar la estratificación y los cambios térmicos costeros.",
    moreInfo: "https://portus.puertos.es/",
  },
  {
    id: "pde-salinity-GIB",
    source: "Puertos del Estado (PDE)",
    layerType: "Heatmap + WebGL",
    format: "NetCDF",
    measureType: "Salinidad (PSU) en el Estrecho de Gibraltar",
    coverage: "Latitudes 35 a 37.2, longitudes –7.42 a –2.99",
    description:
      "Heatmap que ilustra la salinidad en el Estrecho de Gibraltar, determinante para evaluar la densidad y la circulación del agua en zonas de confluencia.",
    moreInfo: "https://portus.puertos.es/",
  },
  {
    id: "pde-salinity-ALM",
    source: "Puertos del Estado (PDE)",
    layerType: "Heatmap + WebGL",
    format: "NetCDF",
    measureType: "Salinidad en la Costa de Almería",
    coverage: "Latitudes 36.46 a 36.86, longitudes –2.65 a –2.21",
    description:
      "Heatmap que muestra las variaciones salinas en la Costa de Almería, fundamental para comprender procesos de evaporación, precipitación y mezcla de masas de agua.",
    moreInfo: "https://portus.puertos.es/",
  },
  {
    id: "pde-currents-GIB",
    source: "Puertos del Estado (PDE)",
    layerType: "Heatmap + WebGL",
    format: "NetCDF",
    measureType: "Corrientes marinas (m/s) en el Estrecho de Gibraltar",
    coverage: "Latitudes 35 a 37.2, longitudes –7.42 a –2.99",
    description:
      "Heatmap que representa las corrientes marinas en el Estrecho de Gibraltar, crucial para el estudio del intercambio de aguas y el transporte de sedimentos.",
    moreInfo: "https://portus.puertos.es/",
  },
  {
    id: "pde-currents-ALM",
    source: "Puertos del Estado (PDE)",
    layerType: "Heatmap + WebGL",
    format: "NetCDF",
    measureType: "Corrientes marinas (m/s) en la Costa de Almería",
    coverage: "Latitudes 36.46 a 36.86, longitudes –2.65 a –2.21",
    description:
      "Heatmap que muestra la dinámica de corrientes a lo largo de la Costa de Almería, ideal para analizar el transporte de energía y sedimentos en ambientes costeros.",
    moreInfo: "https://portus.puertos.es/",
  },
  {
    id: "pde-tiles-currents-gib",
    source: "Puertos del Estado (PDE)",
    layerType: "Tilemap",
    format: "Tiles PNG",
    measureType:
      "Distribución espacial de corrientes (m/s) en el Estrecho de Gibraltar",
    coverage: "Latitudes 35.84 a 36.20, longitudes –5.85 a –4.98",
    description:
      "Tilemaps pregenerados para visualizar la distribución espacial de las corrientes en el Estrecho de Gibraltar, permitiendo análisis a diferentes escalas.",
    moreInfo: "https://portus.puertos.es/",
  },
  {
    id: "pde-tiles-currents-ibi",
    source: "Puertos del Estado (PDE)",
    layerType: "Tilemap",
    format: "Tiles PNG",
    measureType:
      "Distribución espacial de corrientes (m/s) en la región IBI (Iberian-Biscay Irish)",
    coverage: "Latitudes 26.00 a 50.00, longitudes –19.00 a 5.00",
    description:
      "Tilemap pregenerados para visualizar la distribución espacial de las corrientes en la región Iberian-Biscay Iris, permitiendo análisis a diferentes escalas.",
    moreInfo: "https://portus.puertos.es/",
  },
  {
    id: "pde-currents-particles",
    source: "Puertos del Estado (PDE)",
    layerType: "Particles + WebGL",
    format: "NetCDF",
    measureType: "Corrientes marinas (m/s) en el Estrecho de Gibraltar",
    coverage: "Latitudes 35 a 37.2, longitudes –7.42 a –2.99",
    description:
      "Simulación de partículas que muestra dirección y velocidad de las corrientes superficiales en el Estrecho de Gibraltar.",
    moreInfo: "https://portus.puertos.es/",
  },
  {
    id: "boyas-eulerianas",
    source: "Southtek",
    layerType: "Markers (sensores fijos)",
    format: "JSON - API",
    measureType: "Variables oceanográficas en ubicaciones específicas",
    coverage: "Ubicaciones fijas en el océano",
    description:
      "Sensores fijos (boyas eulerianas) que ofrecen datos continuos de variables oceanográficas en ubicaciones específicas, facilitando el monitoreo puntual. Cuentan con gráficas para visualización de series temporales.",
    moreInfo: "https://southteksl.com/",
  },
  {
    id: "boyas-moviles",
    source: "Southtek",
    layerType: "Markers + Pathline (sensores móviles)",
    format: "JSON - API",
    measureType: "Variables oceanográficas con historial de trayectoria.",
    coverage: "Ubicaciones móviles en el océano",
    description:
      "Sensores móviles (boyas lagrangnianas) que ofrecen datos continuos de variables oceanográficas a lo largo de una trayectoria. Sincronizables con la dimensión temporal de los heatmaps.",
    moreInfo: "https://southteksl.com/",
  },
  {
    id: "nasa-bio-0",
    source: "CHELSA Climate",
    layerType: "Heatmap + WebGL",
    format: "GeoTIFF",
    measureType: "Indicadores bioclimáticos",
    coverage:
      "Latitudes –19.45 a 6.62, longitudes –0.97 a 21.74, resolución 40",
    description:
      "Heatmap de indicadores bioclimáticos utilizados en estudios de biodiversidad y distribución de especies.",
    moreInfo: "https://chelsa-climate.org/",
  },
  {
    id: "nasa-bio-1",
    source: "CHELSA Climate",
    layerType: "Heatmap + WebGL",
    format: "GeoTIFF",
    measureType: "Indicadores bioclimáticos",
    coverage:
      "Latitudes –19.45 a 6.62, longitudes –0.97 a 21.74, resolución 40",
    description:
      "Heatmap de indicadores bioclimáticos utilizados en estudios de biodiversidad y distribución de especies.",
    moreInfo: "https://chelsa-climate.org/",
  },
  {
    id: "IGEO-coast-units",
    source: "IGEO - Instituto de Geociencias",
    layerType: "GeoJSON",
    format: "Shapefile - ESRI",
    measureType: "Unidades geológicas de la costa de Angola",
    coverage: "Costa de Angola",
    description:
      "Capa en formato GeoJSON que muestra las unidades geológicas de la costa de Angola, definidas por criterios litológicos y estructurales. Fundamental para identificar formaciones sedimentarias y volcánicas.",
    moreInfo: "http://www.igeo.ucm-csic.es/",
  },
  {
    id: "IGEO-coast-structures",
    source: "IGEO - Instituto de Geociencias",
    layerType: "GeoJSON",
    format: "Shapefile - ESRI",
    measureType: "Estructuras geológicas de la costa de Angola",
    coverage: "Costa de Angola",
    description:
      "Capa en formato GeoJSON que muestra las estructuras geológicas de la costa de Angola, definidas por criterios litológicos y estructurales. Fundamental para identificar formaciones sedimentarias y volcánicas.",
    moreInfo: "http://www.igeo.ucm-csic.es/",
  },
];

const ResourceInfoDialog = ({ visible, onCancel, optionId }) => {
  const option = resourceInfo.find((item) => item.id === optionId);

  return (
    <Modal open={visible} onCancel={onCancel} footer={null}>
      {option ? (
        <Typography>
          <Title level={5} style={{ marginBottom: 4 }}>
            Fuente
          </Title>

          <Text>{option.source}</Text>
          <Divider style={{ margin: "3px 0" }} />
          <Title level={5} style={{ marginBottom: 4 }}>
            Formato de la fuente de datos
          </Title>

          <Text>{option.format}</Text>
          <Divider style={{ margin: "3px 0" }} />
          <Title level={5} style={{ marginBottom: 4 }}>
            Tipo de Capa
          </Title>
          <Text>{option.layerType}</Text>
          <Divider style={{ margin: "3px 0" }} />
          <Title level={5} style={{ marginBottom: 4 }}>
            Medidas
          </Title>
          <Text>{option.measureType}</Text>
          <Divider style={{ margin: "3px 0" }} />
          <Title level={5} style={{ marginBottom: 4 }}>
            Cobertura / Región
          </Title>
          <Text>{option.coverage}</Text>
          <Divider style={{ margin: "3px 0" }} />
          <Title level={5} style={{ marginBottom: 4 }}>
            Descripción
          </Title>
          <Text>{option.description}</Text>
          <Divider style={{ margin: "3px 0" }} />
          <Title level={5} style={{ marginBottom: 4 }}>
            Más Información
          </Title>
          <Paragraph>
            <Link href={option.moreInfo} target="_blank">
              {option.moreInfo}
            </Link>
          </Paragraph>
        </Typography>
      ) : (
        <Text>No hay información disponible para esta opción.</Text>
      )}
    </Modal>
  );
};

export default ResourceInfoDialog;
